import React from 'react';
import JsSIP from 'jssip';

export default class Session extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ringing: false
        };

        this._localClonedStream = null;
    }

    componentDidMount() {
        const session = this.props.session;
        const peerconnection = session.connection;
        const remoteStream = peerconnection.getRemoteStreams()[0];

        // If incoming all we already have the remote stream
        if (remoteStream) {
            this._handleRemoteStream(remoteStream);
        }

        session.on('progress', () => {
            console.log("session progress");
            if (session.direction === 'outgoing') {
                this.setState({ringing: true});
            }
        });

        session.on('accepted', () => {
            console.log("session accepted");
            this.setState({ringing: false});
        });

        session.on('failed', () => {
            console.log("session failed");
            if (session.direction === 'outgoing')
                this.setState({ringing: false});
        });

        session.on('ended', () => {
            console.log("session ended");
            if (session.direction === 'outgoing') {
                this.setState({ringing: false});
            }
        });

        peerconnection.addEventListener('addstream', (event) => {
            this._handleRemoteStream(event.stream);
        });
    }


    componentWillUnmount() {
        JsSIP.Utils.closeMediaStream(this._localClonedStream);
    }


    _handleRemoteStream(stream) {
        const remoteAudio = this.refs.remoteAudio;
        // Display remote stream
        remoteAudio.srcObject = stream;
        stream.addEventListener('addtrack', () => {
            if (remoteAudio.srcObject !== stream)
                return;
            // Refresh remote video
            remoteAudio.srcObject = stream;
        });

        stream.addEventListener('removetrack', () => {
            if (remoteAudio.srcObject !== stream)
                return;
            // Refresh remote video
            remoteAudio.srcObject = stream;
        });
    }


    render() {
        return (
            <div style={{display: 'none'}}>
                <audio ref='remoteAudio' autoPlay />
            </div>
        );
    }
}